
$(document).on('click', ".form-submit .submit", function (){
    var textAreaVal = $('.comment-form-comment').find('textarea').val();
    var authorVal = $('.comment-form-author').find('input').val();
    var emailVal = $('.comment-form-email').find('input').val();
    if (textAreaVal == ''){
        $('.comment-form-comment').find('textarea').addClass('error');
    }
    if (authorVal == ''){
        $('.comment-form-author').find('input').addClass('error');
    }
    if (emailVal == ''){
        $('.comment-form-email').find('input').addClass('error');
    }
    if (textAreaVal != '' && authorVal != ''){

    }
});
$(document).on('change input', ".comment-form-comment textarea, .comment-form-author input,  .comment-form-email input", function (){
    var textAreaVal = $('.comment-form-comment').find('textarea').val();
    var authorVal = $('.comment-form-author').find('input').val();
    var emailVal = $('.comment-form-email').find('input').val();
    $(this).removeClass('error');
    if (textAreaVal != '' && authorVal != '' && emailVal != '') {
        $('.form-submit .submit').addClass('active');
    }
    else {
        $('.form-submit .submit').removeClass('active');
    }
});